import { app } from '../../app.module'
app
  // ユーザー設定フォーム
  .directive('userSettingForm', () => {
    return {
      restrict: 'EA',
      template: require('./user-setting-form.pug')(),
    }
  })
